<template>
  <div class="app-container">
    <div class="filter-container" >
      <el-input class="filter-item" v-model="listQuery.user_id" placeholder="用户ID" style="width: 220px;" clearable size="small"/>
      <el-input class="filter-item" v-model="listQuery.nickname" placeholder="用户昵称" style="width: 220px;" clearable size="small"/>
      <el-input class="filter-item" v-model="listQuery.phone" placeholder="用户手机号" style="width: 220px;" clearable size="small"/>
      <el-input class="filter-item" v-model="listQuery.link_phone" placeholder="预定人手机号" style="width: 220px;" clearable size="small"/>
      <el-input class="filter-item" v-model="listQuery.order_no" placeholder="订单号" style="width: 220px;" clearable size="small"/>
      <el-input class="filter-item" v-model="listQuery.hotel_name" placeholder="酒店名称" style="width: 220px;"
                clearable size="small"/>
      <el-input class="filter-item" v-model="listQuery.room_type_name" placeholder="房型名称名称" style="width: 220px;"
                clearable size="small"/>

      <el-select class="filter-item" v-model="listQuery.status" placeholder="订单状态" style="width: 160px" clearable size="small">
        <el-option label="未支付" :value="0"/>
        <el-option label="预订成功" :value="1"/>
        <el-option label="已取消" :value="2"/>
        <el-option label="预订未到" :value="3"/>
        <el-option label="已入住" :value="4"/>
        <el-option label="已完成" :value="5"/>
        <el-option label="已关闭" :value="6"/>
      </el-select>


      <el-select class="filter-item" v-model="listQuery.pay_status" placeholder="支付状态" style="width: 160px"
                 clearable size="small">
        <el-option label="待支付" :value="1"/>
        <el-option label="支付成功" :value="2"/>
        <el-option label="支付失败" :value="3"/>
        <el-option label="支付取消" :value="4"/>
      </el-select>

      <el-select class="filter-item" v-model="listQuery.comment_status" placeholder="评价状态" style="width: 160px"
                 clearable size="small">
        <el-option label="已评价" :value="1"/>
        <el-option label="未评价" :value="0"/>
      </el-select>
      <el-select class="filter-item" v-model="listQuery.refund_status" placeholder="退款状态" style="width: 160px"
                 clearable size="small">
        <el-option label="未退款" :value="0"/>
        <el-option label="退款中" :value="1"/>
        <el-option label="退款成功" :value="2"/>
        <el-option label="退款失败" :value="3"/>
        <el-option label="部分退款中" :value="4"/>
        <el-option label="部分退款成功" :value="5"/>
      </el-select>

      <el-date-picker class="filter-item" v-model="dateRange" type="daterange" range-separator="至"
                      start-placeholder="入住开始日期" end-placeholder="入住结束日期"
                      value-format="yyyy-MM-dd" size="small" clearable/>

      <el-button class="filter-item" type="primary" @click="handleFilter" size="small">搜索</el-button>
      <el-button class="filter-item" @click="resetFilter" size="small">重置</el-button>
    </div>

    <el-table v-loading="listLoading" :data="list" element-loading-text="Loading" border fit highlight-current-row
              :row-class-name="errorRow">
      <el-table-column label="ID" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.id }}
        </template>
      </el-table-column>
      <el-table-column label="用户ID" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.user_id }}
        </template>
      </el-table-column>
      <el-table-column label="用户头像" min-width="110" align="center">
        <template slot-scope="scope">
          <img v-if="scope.row.user && scope.row.user.avatar" :src="scope.row.user.avatar" class="user-avatar">
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="用户昵称" min-width="110" align="center">
        <template slot-scope="scope">
          {{  scope.row.user?scope.row.user.nickname:"-" }}
        </template>
      </el-table-column>
      <el-table-column label="用户手机号" min-width="110" align="center">
        <template slot-scope="scope">
          {{  scope.row.user?scope.row.user.phone:"-" }}
        </template>
      </el-table-column>
      <el-table-column label="订单号" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.order_no }}
        </template>
      </el-table-column>
      <el-table-column label="预定人手机号" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.link_phone }}
        </template>
      </el-table-column>
      <el-table-column label="酒店名称" min-width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.hotel ? scope.row.hotel.inn_name : "-" }}
        </template>
      </el-table-column>
      <el-table-column label="房型名称" min-width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.room_type ? scope.row.room_type.room_type_name : "-" }}
        </template>
      </el-table-column>
      <el-table-column label="下单时间" min-width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.order_date }}
        </template>
      </el-table-column>

      <el-table-column label="总金额" min-width="140" align="center">
        <template slot-scope="scope">
          ¥{{ money(scope.row.total_money) }}
        </template>
      </el-table-column>

      <el-table-column label="总成本金额" min-width="110" align="center">
        <template slot-scope="scope">
          ¥{{ money(scope.row.total_cost_money) }}
        </template>
      </el-table-column>

      <el-table-column label="入住时间" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.travel_date }}
        </template>
      </el-table-column>

      <el-table-column label="离店时间" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.end_travel_date }}
        </template>
      </el-table-column>


      <el-table-column label="房间间数" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.ticket_num }}
        </template>
      </el-table-column>

      <el-table-column label="订单状态" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag type="primary" v-if="scope.row.status === 0">未支付</el-tag>
          <el-tag type="primary" v-if="scope.row.status === 1">预订成功</el-tag>
          <el-tag type="danger" v-else-if="scope.row.status === 2">已取消</el-tag>
          <el-tag type="warning" v-else-if="scope.row.status === 3">预订未到</el-tag>
          <el-tag type="warning" v-else-if="scope.row.status === 4">已入住</el-tag>
          <el-tag type="success" v-else-if="scope.row.status === 5">已完成</el-tag>
          <el-tag type="danger" v-else-if="scope.row.status === 6">已关闭</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="支付状态" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.pay_status === 1">待支付</el-tag>
          <el-tag type="warning" v-else-if="scope.row.pay_status === 2">支付成功</el-tag>
          <el-tag type="danger" v-else-if="scope.row.pay_status === 3">支付失败</el-tag>
          <el-tag type="danger" v-else-if="scope.row.pay_status === 4">支付取消</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="支付时间" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.pay_at }}
        </template>
      </el-table-column>
      <el-table-column label="评价状态" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.comment_status === 1">已评价</el-tag>
          <el-tag type="warning" v-else-if="scope.row.comment_status === 0">未评价</el-tag>

        </template>
      </el-table-column>
      <el-table-column label="评价时间" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.comment_at }}
        </template>
      </el-table-column>
      <el-table-column label="退款状态" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag type="warning" v-if="scope.row.refund_status === 0">未退款</el-tag>
          <el-tag type="warning" v-else-if="scope.row.refund_status === 1">退款中</el-tag>
          <el-tag type="success" v-else-if="scope.row.refund_status === 2">退款成功</el-tag>
          <el-tag type="danger" v-else-if="scope.row.refund_status === 3">退款失败</el-tag>
          <el-tag type="warning" v-else-if="scope.row.refund_status === 4">部分退款中</el-tag>
          <el-tag type="success" v-else-if="scope.row.refund_status === 5">部分退款成功</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="已退/退款中" min-width="140" align="center">
        <template slot-scope="scope">¥{{ money(scope.row.refunded_amount) }} / ¥{{ money(scope.row.refunding_amount) }}</template>
      </el-table-column>
      <el-table-column label="退款时间" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.refund_at }}
        </template>
      </el-table-column>
      <el-table-column label="取消时间" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.cancel_at }}
        </template>
      </el-table-column>
      <el-table-column label="操作处理失败信息" min-width="140" align="center">
        <template slot-scope="scope">
          {{ scope.row.handle_error_message }}
        </template>
      </el-table-column>

      <el-table-column label="创建时间" min-width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.created_at }}
        </template>
      </el-table-column>

      <el-table-column label="操作" width="360" align="center" fixed="right" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button type="warning" size="mini" @click="handleCancelOrder(scope.row)"
                     :disabled="!(scope.row.pay_status === 1)">取消订单
          </el-button>
          <el-button v-if="canManageRefund" type="warning" size="mini" @click="refund(scope.row)"
                     :disabled="(scope.row.pay_status != 2||scope.row.refund_status == 2)">退款
          </el-button>
          <el-button v-if="canManageRefund" type="primary" size="mini" @click="openPartialRefund(scope.row)"
                     :disabled="partialRefundDisabled(scope.row)"
                     :title="partialRefundDisabledReason(scope.row)">部分退款</el-button>
          <el-button v-if="canViewRefund" size="mini" @click="openRefundRecords(scope.row)">退款记录</el-button>

<!--          <el-button type="warning" size="mini" @click="handleComplete(scope.row)"-->
<!--                     :disabled="handleCompleteStatus(scope.row)">处理完成-->
<!--          </el-button>-->
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination :current-page="listQuery.page" :page-sizes="[5,10,20,30,50]" :page-size="listQuery.limit"
                     :total="total" background layout="total, sizes, prev, pager, next, jumper"
                     @size-change="handleSizeChange" @current-change="handleCurrentChange"/>
    </div>

    <!-- 修改到店时间 -->
    <el-dialog title="修改到店时间" :visible.sync="dialogVisibleModifyLastArrTime" width="60%"
               :close-on-click-modal="false">
      <el-form ref="modifyLastArrTimeForm" :rules="modifyLastArrTimeRules" :model="modifyLastArrTimeForm"
               label-width="150px">
        <el-form-item label="修改到店时间" prop="last_arr_time">
          <el-date-picker v-model="modifyLastArrTimeForm.last_arr_time" type="datetime" placeholder="选择日期时间"
                          format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleModifyLastArrTime = false">取消</el-button>
        <el-button type="primary" @click="saveDataModifyLastArrTime" :loading="btnLoading">确定</el-button>
      </div>
    </el-dialog>
    <!-- 修改到店时间 -->
    <el-dialog title="部分退款" :visible.sync="partialRefundVisible" width="520px" :close-on-click-modal="false">
      <el-alert title="部分退款不会取消供应商订单；退款成功后该订单不发放佣金。" type="warning" :closable="false" show-icon/>
      <el-form ref="partialRefundForm" :model="partialRefundForm" :rules="partialRefundRules" label-width="130px" style="margin-top:18px">
        <el-form-item label="订单号">{{ partialRefundForm.order_no }}</el-form-item>
        <el-form-item label="支付金额">¥{{ refundPreview.pay_amount || "0.00" }}</el-form-item>
        <el-form-item label="已退款金额">¥{{ refundPreview.refunded_amount || "0.00" }}</el-form-item>
        <el-form-item label="退款中金额">¥{{ refundPreview.refunding_amount || "0.00" }}</el-form-item>
        <el-form-item label="剩余可退金额">¥{{ refundPreview.available_refund_amount || "0.00" }}</el-form-item>
        <el-form-item label="本次退款金额" prop="refund_amount">
          <el-input-number v-model="partialRefundForm.refund_amount" :precision="2" :step="0.01" :min="0.01" :max="Number(refundPreview.available_refund_amount || 0)"/>
        </el-form-item>
        <el-form-item label="退款备注" prop="remark">
          <el-input v-model.trim="partialRefundForm.remark" type="textarea" :rows="4" maxlength="500" show-word-limit/>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="partialRefundVisible=false">取消</el-button>
        <el-button type="danger" :loading="refundSubmitting" @click="submitPartialRefund">确认提交退款</el-button>
      </div>
    </el-dialog>

    <el-dialog title="退款记录" :visible.sync="refundRecordsVisible" width="85%">
      <el-table :data="refundRecords" border v-loading="refundRecordsLoading">
        <el-table-column prop="refund_no" label="退款单号" min-width="210"/>
        <el-table-column prop="refund_amount" label="退款金额" width="110"/>
        <el-table-column label="状态" width="100"><template slot-scope="scope">{{ refundRecordStatusText(scope.row.status) }}</template></el-table-column>
        <el-table-column prop="remark" label="备注" min-width="220"/>
        <el-table-column prop="operator_name" label="操作人" width="120"/>
        <el-table-column prop="failure_message" label="失败原因" min-width="180"/>
        <el-table-column prop="created_at" label="创建时间" width="170"/>
        <el-table-column prop="success_at" label="成功时间" width="170"/>
        <el-table-column label="操作" width="210"><template slot-scope="scope">
          <el-button v-if="scope.row.status === 1 || scope.row.status === 3" size="mini" @click="queryRefund(scope.row)">查询</el-button>
          <el-button v-if="scope.row.status === 3" type="warning" size="mini" @click="retryRefund(scope.row)">重试</el-button>
          <el-button v-if="scope.row.status === 0 || scope.row.status === 3" type="danger" size="mini" @click="closeRefund(scope.row)">关闭</el-button>
        </template></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import request from "@/utils/request";

export default {
  data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      listQuery: this.defaultListQuery(),
      dateRange: [],
      // 修改到店时间
      btnLoading: false,
      dialogVisibleModifyLastArrTime: false,
      modifyLastArrTimeForm: {
        order_id: "",
        last_arr_time: "",
      },
      modifyLastArrTimeRules: {
        last_arr_time: [{required: true, message: "到店时间不能为空", trigger: "change"}],
      },
      partialRefundVisible: false,
      refundSubmitting: false,
      refundPreview: {},
      partialRefundForm: {order_no: "", refund_amount: 0.01, remark: "", idempotency_key: ""},
      partialRefundRules: {
        refund_amount: [{required: true, message: "请输入退款金额", trigger: "change"}],
        remark: [{required: true, min: 5, max: 500, message: "退款备注需填写5到500个字符", trigger: "blur"}]
      },
      refundRecordsVisible: false,
      refundRecordsLoading: false,
      refundRecords: [],
      refundRecordOrderNo: "",
    };
  },
  computed: {
    canViewRefund() {
      const permissions = this.$store.getters.permissions || [];
      return permissions.some(item => ["all", "admin", "order.refund.view", "order.refund.manage"].includes(item));
    },
    canManageRefund() {
      const permissions = this.$store.getters.permissions || [];
      return permissions.some(item => ["all", "admin", "order.refund.manage"].includes(item));
    }
  },
  created() {
    this.getList();
  },
  methods: {
    defaultListQuery() {
      return {page: 1, limit: 10, user_id: "", nickname: "", phone: "", link_phone: "", order_no: "", hotel_name: "", room_type_name: "", status: "", pay_status: "", comment_status: "", refund_status: "", start_at: "", end_at: ""};
    },
    money(value) {
      const number = Number(value);
      return Number.isFinite(number) ? number.toFixed(2) : "0.00";
    },
    getList() {
      this.listLoading = true;
      this.listQuery.start_at = this.dateRange && this.dateRange.length ? this.dateRange[0] : "";
      this.listQuery.end_at = this.dateRange && this.dateRange.length ? this.dateRange[1] : "";
      request({
        url: "/api/backend/order/orderList",
        method: "get",
        params: this.listQuery,
      }).then(response => {
        this.list = response.data.items;
        this.total = response.data.total;
      }).finally(() => { this.listLoading = false; });
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    errorRow({row}) {
      let errorStatus = [102, 202];
      if (errorStatus.includes(row.system_order_status) && row.error_order_handle_status === 0) {
        return "error-row";
      }
      return "";
    },
    // 修改到店时间
    handleModifyLastArrTime(row) {
      this.modifyLastArrTimeForm = {
        order_id: row.order_id,
        last_arr_time: "",
      };
      this.dialogVisibleModifyLastArrTime = true;
      this.$nextTick(() => {
        this.$refs["modifyLastArrTimeForm"].clearValidate(); //清除校验结果
      });
    },
    saveDataModifyLastArrTime() {
      this.$refs["modifyLastArrTimeForm"].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          request({
            url: "/api/backend/order/modifyLastArrTime",
            method: "post",
            data: this.modifyLastArrTimeForm
          }).then(() => {
            this.dialogVisibleModifyLastArrTime = false;
            this.$message({
              type: "success",
              message: "操作成功"
            });
            this.getList();
          }).finally(() => {
            this.btnLoading = false;
          });
        }
      });
    },
    // 重新下单
    handleReOrder(row) {
      this.$confirm("确认继续该操作", "提示", {
        type: "warning"
      }).then(() => {
        request({
          url: "/api/backend/order/reOrder",
          method: "post",
          data: {
            order_id: row.order_id
          }
        }).then(() => {
          this.getList();
          this.$message({
            type: "success",
            message: "操作成功"
          });
        });
      }).catch(() => {
      });
    },
    // 取消订单
    handleCancelOrder(row) {
      this.$confirm("确认继续该操作", "提示", {
        type: "warning"
      }).then(() => {
        request({
          url: "/api/backend/order/cancelOrder",
          method: "post",
          data: {
            order_no: row.order_no
          }
        }).then(() => {
          this.getList();
          this.$message({
            type: "success",
            message: "操作成功"
          });
        });
      }).catch(() => {
      });
    },
    // 退款
    refund(row) {
      this.$confirm("确认继续该操作", "提示", {
        type: "warning"
      }).then(() => {
        request({
          url: "/api/backend/order/refund",
          method: "post",
          data: {
            order_no: row.order_no
          }
        }).then(() => {
          this.getList();
          this.$message({
            type: "success",
            message: "操作成功"
          });
        });
      }).catch(() => {
      });
    },
    resetFilter() {
      const limit = this.listQuery.limit;
      this.listQuery = this.defaultListQuery();
      this.listQuery.limit = limit;
      this.dateRange = [];
      this.getList();
    },
    makeIdempotencyKey() {
      return "admin-refund-" + Date.now() + "-" + Math.random().toString(36).slice(2, 12);
    },
    partialRefundDisabled(row) {
      return row.pay_status !== 2 || row.status !== 5 || [1, 2].includes(Number(row.refund_status)) ||
        Number(row.refunding_amount || 0) > 0 || Number(row.refunded_amount || 0) >= Number(row.pay_money || 0);
    },
    partialRefundDisabledReason(row) {
      if (row.status !== 5) return "仅已完成订单允许部分退款";
      if (row.pay_status !== 2) return "订单尚未支付成功";
      if ([1, 2].includes(Number(row.refund_status))) return "订单正在全额退款或已全额退款";
      if (Number(row.refunding_amount || 0) > 0) return "订单已有退款处理中";
      if (Number(row.refunded_amount || 0) >= Number(row.pay_money || 0)) return "订单没有剩余可退金额";
      return "";
    },
    openPartialRefund(row) {
      if (row.status !== 5) {
        this.$message.warning("仅已完成状态的订单允许部分退款");
        return;
      }
      request({
        url: "/api/backend/order/refund-preview",
        method: "get",
        params: {order_no: row.order_no, order_category: "order"}
      }).then(response => {
        if (!response.data.partial_refund_allowed) {
          this.$message.warning("订单状态已变化，仅已完成订单允许部分退款");
          return;
        }
        this.refundPreview = response.data;
        this.partialRefundForm = {
          order_no: row.order_no,
          refund_amount: Math.min(0.01, Number(response.data.available_refund_amount || 0)),
          remark: "",
          idempotency_key: this.makeIdempotencyKey()
        };
        this.partialRefundVisible = true;
        this.$nextTick(() => this.$refs.partialRefundForm && this.$refs.partialRefundForm.clearValidate());
      });
    },
    submitPartialRefund() {
      this.$refs.partialRefundForm.validate(valid => {
        if (!valid) return;
        if (!this.refundPreview.partial_refund_allowed) {
          this.$message.error("仅已完成状态的订单允许部分退款");
          return;
        }
        const amount = Number(this.partialRefundForm.refund_amount);
        const available = Number(this.refundPreview.available_refund_amount);
        if (amount <= 0 || amount > available) {
          this.$message.error("退款金额必须大于0且不能超过剩余可退金额");
          return;
        }
        this.$confirm(`确认对订单 ${this.partialRefundForm.order_no} 退款 ¥${amount.toFixed(2)}？`, "高风险操作确认", {type: "warning"})
          .then(() => {
            this.refundSubmitting = true;
            const confirmedAmount = amount.toFixed(2);
            const data = Object.assign({}, this.partialRefundForm, {
              order_category: "order",
              refund_amount: confirmedAmount,
              confirmed_refund_amount: confirmedAmount
            });
            return request({
              url: "/api/backend/order/partial-refund",
              method: "post",
              data
            });
          }).then(() => {
            this.partialRefundVisible = false;
            this.$message.success("退款申请已创建，请在退款记录中查看进度");
            this.getList();
          }).finally(() => { this.refundSubmitting = false; });
      });
    },
    openRefundRecords(row) {
      this.refundRecordOrderNo = row.order_no;
      this.refundRecordsVisible = true;
      this.loadRefundRecords();
    },
    loadRefundRecords() {
      this.refundRecordsLoading = true;
      request({
        url: "/api/backend/order/refund-list",
        method: "get",
        params: {order_no: this.refundRecordOrderNo, order_category: "order", limit: 100}
      }).then(response => {
        this.refundRecords = response.data.items || response.data.data || [];
      }).finally(() => { this.refundRecordsLoading = false; });
    },
    retryRefund(row) {
      this.$confirm(`确认重试退款单 ${row.refund_no}？`, "提示", {type: "warning"}).then(() => request({
        url: "/api/backend/order/refund-retry",
        method: "post",
        data: {refund_no: row.refund_no}
      })).then(() => {
        this.$message.success("退款重试完成");
        this.loadRefundRecords();
        this.getList();
      });
    },
    queryRefund(row) {
      request({url: "/api/backend/order/refund-query", method: "post", data: {refund_no: row.refund_no}}).then(() => {
        this.$message.success("退款状态已更新");
        this.loadRefundRecords();
        this.getList();
      });
    },
    closeRefund(row) {
      this.$confirm("确认关闭该退款并释放预占金额？", "提示", {type: "warning"}).then(() => request({
        url: "/api/backend/order/refund-close", method: "post", data: {refund_no: row.refund_no}
      })).then(() => { this.loadRefundRecords(); this.getList(); });
    },
    refundRecordStatusText(status) {
      return ({0: "待处理", 1: "处理中", 2: "成功", 3: "失败", 4: "已关闭"})[status] || "未知";
    },
    // 处理完成
    handleComplete(row) {
      this.$confirm("确认继续该操作", "提示", {
        type: "warning"
      }).then(() => {
        request({
          url: "/api/backend/order/handleComplete",
          method: "post",
          data: {
            order_id: row.order_id
          }
        }).then(() => {
          this.getList();
          this.$message({
            type: "success",
            message: "操作成功"
          });
        });
      }).catch(() => {
      });
    },
    handleCompleteStatus(row) {
      let errorStatus = [102, 202];
      return !(errorStatus.includes(row.system_order_status) && row.error_order_handle_status === 0)
    },
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
::v-deep .el-table .error-row {
  background-color: rgba(255, 0, 0, 0.2);
}
.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 6px;
}
</style>
